module.exports = __webpack_public_path__ + "static/media/sell_resend_invoice_2.b8f7dab5.jpg";